<template>
  <router-view class="content"></router-view>
</template>

<script>
export default {
  name: "SalesMainPage"
};
</script>

<style></style>
